import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import STF_CONSTANTS from "./stfConstant.service";
import Storage from "./storage.service";
import axios from "axios";
import Settings from "./settings.service";
import Translations from "./translation.service";
import * as variables from "../variables";
import User from "./user.service";
import Numbers from "./numbers.service";
import CONSTANTS from "./constants.service";

var storefront = {};
const HTTPOverride = axios.create();

storefront.fetchCategory = () => {
  let config = {
    method: "get",
    url: "/store_front/categories",
    headers: {
      "Virgin-Brand": "virgin",
    },
  };
  return HTTP(config);
};
storefront.sortData = (array, filterKey) => {
  return array.sort((a, b) => (a[filterKey] > b[filterKey] ? 1 : -1));
};
storefront.getPlanDataMinValue = (dataValue, type) => {
  let value = 0;
  if (dataValue) {
    if (type === STF_CONSTANTS.DATA_TYPE || type === variables.PROMOTION_TYPE_DATA || type === variables.PROMOTION_TYPE_DATA_SOCIAL || type === variables.PROMOTION_TYPE_DATA_ROM) {
      value = dataValue !== -1 ? Helpers.bytesToGBs(dataValue) : -1;
    } else if (type === STF_CONSTANTS.MINUTE_TYPE || type === variables.PROMOTION_TYPE_VOICE_LCL || type === variables.PROMOTION_TYPE_VOICE_INT ||  type === variables.PROMOTION_TYPE_VOICE_FLEXI) {
      value = dataValue !== -1 ? Helpers.milisecondstoMinutes(dataValue) : -1;
    } else if (type === STF_CONSTANTS.SMS_TYPE || type === variables.PROMOTION_TYPE_SMS) {
        value = dataValue !== -1 ? dataValue : -1;
    }
  }
  return value;
};

storefront.getTransformedPlanTypeValues = (dataValue, unit) => {
  if(dataValue === -1) {
    return -1
  } else {
    let value = 0;
    if (dataValue && unit) {
      switch (unit) {
        case "sms":
        case "SMS":
        case "Sms":
          value = dataValue;
          break;
        case "bytes":
        case "BYTES":
        case "Bytes":
          value = Helpers.bytesToGBs(dataValue);
          break;
        case "milliseconds":
        case "MILLISECONDS":
        case "Milliseconds":
          value = Helpers.milisecondstoMinutes(dataValue);
          break;
        case "minute":
        case "MINUTE":
        case "Minute":
        case "minutes":
        case "MINUTES":
        case "Minutes":
        case "min":
        case "MIN":
        case "Min":
          value = dataValue;
          break;
        default:
          break;
      }
    }
    return value;
  }
};

storefront.getPoImage = (po_name, key) => {
  let requiredPoImage = "";
  if (key) {
    let poImage = Storage.get(po_name, true);
    poImage = poImage !== "undefined" ? JSON.parse(poImage) : "";
    if (poImage?.[key]?.url) {
      requiredPoImage = poImage[key].url;
    }
  }

  return requiredPoImage;
};

storefront.getPoBgColor = (po_name, key, defualt_color) => {
  let requiredPoImage = "";
  if (key) {
    let poImage = Storage.get(po_name, true);
    poImage = poImage !== "undefined" ? JSON.parse(poImage) : "";
    if (poImage?.[key]) {
      requiredPoImage = poImage[key];
    } else {
      requiredPoImage = defualt_color;
    }
  }
  return requiredPoImage;
};

storefront.fetchBannerImagesWP = (lang, responseCall) => {
  let config = {
    method: "get",
    url: Settings.banner_api + "&lang=" + lang,
  };
  HTTPOverride(config)
    .then((response) => {
      responseCall(response);
    })
    .catch((error) => {
      // Storage.set("menuLoading", false);
    });
};

storefront.getDuration = (duration, extended_validity) => {
  let durationField = "";

  if (duration === -1) {
    //If unlimited
    durationField = -1;
  } else {
    durationField = Helpers.monthsInDay(duration);
    if (durationField === 1) {
      durationField +=
        " " + Translations.keys["content_offer_duration_label_singular"];
    } else {
      if (extended_validity) {
        let extendedValidityInMonths = Helpers.monthsInDay(extended_validity);
        durationField =
          Helpers.monthsInDay(duration - extended_validity) +
          " + " +
          extendedValidityInMonths +
          " " +
          Translations.keys["content_offer_duration_label_plural"];
      } else {
        durationField +=
          " " + Translations.keys["content_offer_duration_label_plural"];
      }
    }
  }
  return durationField;
};

storefront.tabHorizontalScroll = (id_subtext, id) => {
  const tabSlider = document.getElementById(id_subtext + id);
  if (tabSlider) {
    tabSlider.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }
};

storefront.tabHorizontalScrollPlans = (id_subtext, id) => {
  const tabSlider = document.getElementById(id_subtext + id);
  const container = tabSlider?.parentNode;

  if (tabSlider && container) {
    const containerRect = container.getBoundingClientRect();
    const tabSliderRect = tabSlider.getBoundingClientRect();

    // Calculate the offset to scroll the element to the center of the container
    const offsetToCenter = tabSliderRect.left - containerRect.left 
                           - (container.clientWidth / 2) 
                           + (tabSlider.clientWidth / 2);

    container.scrollBy({
      left: offsetToCenter,
      behavior: "smooth"
    });
  }
};

storefront.selectCategory = (cta, title = "", toggleLoader = () => { }) => {
  // Synced
  toggleLoader(true);
  if (STF_CONSTANTS.CTA_I_WANT_THIS_NUMBER === cta) {
    Numbers.postNumber(title)
      .then((response) => {
        toggleLoader(true);
        Storage.set("is_web_category_selected", true, true);
        Storage.set("web_random_number_skip", true, true);
        User.fetchFlowStatus()
          .then((response) => {
            toggleLoader(false);
          })
          .catch((err) => {
            toggleLoader(false);
          });
      })
      .catch((error) => {
        toggleLoader(false);
      });
  } else {
    Storage.set("is_web_category_selected", true, true);
    if (STF_CONSTANTS.CTA_GENERATE_NOW === cta) {
      // Do Nothing, root node is random number.
    } else if (STF_CONSTANTS.CTA_BRING_YOUR_NUMBER === cta) {
      // Handling for MNP in KW
      Storage.set("choose_mnp", true, true);
      // Handling for MNP in KSA
      Storage.set("chose_mnp", true, true);
    } else if (STF_CONSTANTS.CTA_VIEW_ALL === cta) {
      Storage.set("web_search_more_number", true, true);
    }
    User.fetchFlowStatus()
      .then((response) => {
        toggleLoader(false);
      })
      .catch((err) => {
        toggleLoader(false);
      });
  }
};

storefront.selectCustomPlan = (cardType) => {
  const is5g = (cardType === "5G Home broardband plans" || cardType === "5G plans");
  Helpers.handleProductCode(CONSTANTS.REGULAR_PRODUCT_ATTR);
  Storage.set("is_category_type_5g", is5g, true);
  Storage.set("is_custom_card_selected", true, true);
  Storage.set("is_web_category_selected", true, true);
  Storage.set("choose_plan_category", true, true);
  User.fetchFlowStatus();
};

storefront.selectPlan = (cardType = "", planDetails = {}) => {
  if(planDetails?.ExtraDetails) {
    let extraData = JSON.parse(planDetails?.ExtraDetails)
    Storage.set("pre-defined-plan-selected", extraData?.PlanCode, true);
    Storage.set("pre-defined-plan-selected-detail", JSON.stringify(extraData), true);
  }
  if (planDetails?.ProductCode) {
    const ActiveProductCodes = planDetails?.ProductCode;
    Storage.set("pre-defined-plan-selected-product-code", ActiveProductCodes, true);
    Storage.set("ActiveProductCodes", ActiveProductCodes, true);
  }
  const is5g = (cardType === "5G Home broardband plans" || cardType === "5G plans");
  Storage.set("is_category_type_5g", is5g, true);
  Storage.set("is_custom_card_selected", false, true);
  Storage.set("is_web_category_selected", true, true);
  Storage.set("choose_plan_category", true, true);
  User.fetchFlowStatus();
};

storefront.selectTopUp = (topUpAmount) => {
  Storage.set("topup_category_data", topUpAmount, true);
  Storage.set("is_web_category_selected", true, true);
  Storage.set("choose_topup_category", true, true);
  User.fetchFlowStatus();
}

storefront.fetchPrepaidPlanSuggestions = () => {
  let config = {
    method: "get",
    url: "store_front/prepaid_plans",
    headers: {
      "Virgin-Brand": "virgin",
    },
  };
  return HTTP(config);
}

storefront.fetchPostpaidPlanSuggestions = () => {
  let config = {
    method: "get",
    url: "store_front/postpiad_plan_suggestion",
    headers: {
      "Virgin-Brand": "virgin",
    },
  };
  return HTTP(config);
}

storefront.getSumData = (promotions, vairableType, dataType) => {
  let sumValue = "";

  const freePlanPromotions = promotions.filter(
    (promotion) => promotion["Type"] === variables.PROMOTION_TYPE_FREE_PLAN
  );
  let promotionType = freePlanPromotions.find(
    (promotion) => JSON.parse(promotion?.Value)?.Type === vairableType
  );

  if (promotionType) {
    const parsedValue = JSON.parse(promotionType["Value"]);

    if (dataType === "gb") {
      const gbs = Helpers.bytesToGBs(parsedValue.Value);

      sumValue = parsedValue.Value === -1 ? -1 : sumValue + gbs;

      if (promotionType.ExtendedValidity && parsedValue.Value !== -1)
        sumValue += "+" + gbs;
    } else if (dataType === "min") {
      const mins = Helpers.milisecondstoMinutes(parsedValue.Value);
      sumValue = parsedValue.Value === -1 ? -1 : sumValue + mins;
      if (promotionType.ExtendedValidity && parsedValue.Value !== -1)
        sumValue += "+" + mins;
    }
  }

  return sumValue;
};

storefront.getValidity = (plans) => {
  const filteredPlans = plans.filter(
    (item) =>
      item?.Type === variables.PROMOTION_TYPE_DATA ||
      item?.Type === variables.PROMOTION_TYPE_VOICE_LCL
  );

  if (filteredPlans.length > 0) return filteredPlans[0]?.Validity;
  return 0;
};

storefront.data = () => {
  return {
    // MainCategoryList:
    // [
    //   {
    //     "Id": 23,
    //     "DeepLink": "httptest",
    //     "Name": "Plans",
    //     "Order": 3,
    //     "NameKey": "main_category_23_name",
    //     "NameColor": "main_category_23_color",
    //     "Icon": "main_category_23_icon",
    //     "SubCategoryList": [
    //       {
    //         "Id": 37,
    //         "Name": "5G Home broardband plans",
    //         "NameKey": "subcategory_37_name",
    //         "NameColor": "subcategory_37_color",
    //         "DescriptionKey": "subcategory_37_description",
    //         "DescriptionColor": "subcategory_37_DescriptionColor",
    //         "Order": 1,
    //         "CTA": "CTA",
    //         "CTA_Title": "subcategory_37_cta_title",
    //         "Cards": [
    //           {
    //             "Id": 158,
    //             "Order": 2,
    //             "Shape": "VerticalCard",
    //             "CardList": [
    //               {
    //                 "Id": 100,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "100GB5G1Month",
    //                 "ProductCode": 8,
    //                 "ImageSize": "Medium",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_100_cta_title",
    //                 "ImageKey": "card_100_image",
    //                 "Order": 1,
    //                 "CTA": "Predefined Specific Plan",
    //                 "ExtraDetails": "{\"ID\":2497,\"Name\":\"100GB5G1Month\",\"IsPopular\":false,\"OriginalPrice\":150.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":150.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":150.0,\"OriginalPriceVATExc\":153.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"100GB5G1Month\",\"Plan\":[{\"Name\":\"100GB 5G 1Month\",\"Type\":\"DATA\",\"Value\":107374182400.0,\"Unit\":\"bytes\",\"PlanID\":830,\"ChargingType\":\"RenewableBundle\",\"Validity\":30}],\"Promotions\":[],\"MonthlyNetCost\":150.000,\"MonthlyDiscountedPrice\":150.000,\"simType\":\"both\"}"
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 152,
    //             "Order": 4,
    //             "Shape": "HorizontalCard",
    //             "CardList": [
    //               {
    //                 "Id": 94,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "Super215New",
    //                 "ProductCode": 1,
    //                 "ImageSize": "Large",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_94_cta_title",
    //                 "ImageKey": "card_94_image",
    //                 "Order": 1,
    //                 "CTA": "Predefined Specific Plan",
    //                 "ExtraDetails": "{\"ID\":2122,\"Name\":\"Super215New\",\"IsPopular\":false,\"OriginalPrice\":215.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":215.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":215.0,\"OriginalPriceVATExc\":215.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"Super215New\",\"Plan\":[{\"Name\":\"5KMin-NEW\",\"Type\":\"VOICE-LCL\",\"Value\":300000000.0,\"Unit\":\"milliseconds\",\"PlanID\":576,\"ChargingType\":\"RenewableBundle\",\"Validity\":30},{\"Name\":\"80GB-NEW\",\"Type\":\"DATA\",\"Value\":85899345920.0,\"Unit\":\"bytes\",\"PlanID\":792,\"ChargingType\":\"RenewableBundle\",\"Validity\":30}],\"Promotions\":[{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":195,\\\"Type\\\":\\\"STARZPLAY\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":40.000,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_StarzPlayUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":342,\\\"Type\\\":\\\"OSN\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.750,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_OSNUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":426,\\\"Type\\\":\\\"UFC\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UFCUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":431,\\\"Type\\\":\\\"Discovery\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":14.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_DiscoveryUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":186,\\\"Type\\\":\\\"ANGHAMI\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.500,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_AnghamiUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":517,\\\"Type\\\":\\\"DATA-SOCIAL\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":-1,\\\"Duration\\\":30.0,\\\"Commitment\\\":0,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":0.0,\\\"IsOptional\\\":false,\\\"IsSelected\\\":true,\\\"GroupName\\\":null,\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":true,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UnlimitedSocial_80GB5KMin\",\"IsMetrics\":true,\"ExtendedValidity\":0,\"Validity\":0}],\"MonthlyNetCost\":215.000,\"MonthlyDiscountedPrice\":215.000,\"simType\":\"both\"}"
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 151,
    //             "Order": 6,
    //             "Shape": "HorizontalCard",
    //             "CardList": [
    //               {
    //                 "Id": 93,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "Super380",
    //                 "ProductCode": 1,
    //                 "ImageSize": "Medium",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_93_cta_title",
    //                 "ImageKey": "card_93_image",
    //                 "Order": 1,
    //                 "CTA": "Predefined Specific Plan",
    //                 "ExtraDetails": "{\"ID\":713,\"Name\":\"Super380\",\"IsPopular\":false,\"OriginalPrice\":380.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":380.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":380.0,\"OriginalPriceVATExc\":480.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"Super380\",\"Plan\":[{\"Name\":\"1000GB-NEW\",\"Type\":\"DATA\",\"Value\":-1.0,\"Unit\":\"bytes\",\"PlanID\":506,\"ChargingType\":\"RenewableBundle\",\"Validity\":30},{\"Name\":\"UnlimitedLocalMin\",\"Type\":\"VOICE-LCL\",\"Value\":-1.0,\"Unit\":\"milliseconds\",\"PlanID\":515,\"ChargingType\":\"RenewableBundle\",\"Validity\":30}],\"Promotions\":[{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":195,\\\"Type\\\":\\\"STARZPLAY\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":40.000,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_StarzPlayUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":342,\\\"Type\\\":\\\"OSN\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.750,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_OSNUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":426,\\\"Type\\\":\\\"UFC\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UFCUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":431,\\\"Type\\\":\\\"Discovery\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":14.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_DiscoveryUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":186,\\\"Type\\\":\\\"ANGHAMI\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.500,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_AnghamiUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":517,\\\"Type\\\":\\\"DATA-SOCIAL\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":-1,\\\"Duration\\\":30.0,\\\"Commitment\\\":0,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":0.0,\\\"IsOptional\\\":false,\\\"IsSelected\\\":true,\\\"GroupName\\\":null,\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":true,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UnlimitedSocial_UnlimitedGBUnlimitedMin\",\"IsMetrics\":true,\"ExtendedValidity\":0,\"Validity\":0}],\"MonthlyNetCost\":380.000,\"MonthlyDiscountedPrice\":380.000,\"simType\":\"both\"}",
    //                 "eSIM": false
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 160,
    //             "Order": 7,
    //             "Shape": "HorizontalCard",
    //             "CardList": [
    //               {
    //                 "Id": 102,
    //                 "Type": "DefaultBanner",
    //                 "CTA_Title": "card_102_cta_title",
    //                 "ImageKey": "card_102_image",
    //                 "Order": 1,
    //                 "Title": "Explore All Plans",
    //                 "Description1": "Choose any plan you want for your number"
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 162,
    //             "Order": 8,
    //             "Shape": "SwipeBanner",
    //             "CardList": [
    //               {
    //                 "Id": 104,
    //                 "Type": "CustomizedPlanBanner",
    //                 "CTA_Title": "card_104_cta_title",
    //                 "ImageKey": "card_104_image",
    //                 "Order": 1,
    //                 "Title": "Create your plan",
    //                 "Description1": "lorem ipsum is simply dummy text for printing and typesetting industry."
    //               },
    //               {
    //                 "Id": 105,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "Super70",
    //                 "ProductCode": 1,
    //                 "ImageSize": "Medium",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_105_cta_title",
    //                 "ImageKey": "card_105_image",
    //                 "Order": 2,
    //                 "CTA": "Predefined Specific Plan",
    //                 "ExtraDetails": "{\"ID\":709,\"Name\":\"Super70\",\"IsPopular\":false,\"OriginalPrice\":70.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":70.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":70.0,\"OriginalPriceVATExc\":115.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"Super70\",\"Plan\":[{\"Name\":\"15GB-NEW\",\"Type\":\"DATA\",\"Value\":16106127360.0,\"Unit\":\"bytes\",\"PlanID\":501,\"ChargingType\":\"RenewableBundle\",\"Validity\":30},{\"Name\":\"500Min-NEW\",\"Type\":\"VOICE-LCL\",\"Value\":30000000.0,\"Unit\":\"milliseconds\",\"PlanID\":509,\"ChargingType\":\"RenewableBundle\",\"Validity\":30}],\"Promotions\":[],\"MonthlyNetCost\":70.000,\"MonthlyDiscountedPrice\":70.000,\"simType\":\"both\"}"
    //               },
    //               {
    //                 "Id": 106,
    //                 "Type": "CustomizedPlanBanner",
    //                 "ImageSize": "Large",
    //                 "CTA_Title": "card_106_cta_title",
    //                 "ImageKey": "card_106_image",
    //                 "Order": 3,
    //                 "Title": "Create your plan",
    //                 "Description1": "lorem ipsum is simply dummy text for printing and typesetting industry."
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 163,
    //             "Order": 9,
    //             "Shape": "HorizontalCard",
    //             "CardList": [
    //               {
    //                 "Id": 107,
    //                 "Type": "CustomizedPlanBanner",
    //                 "CTA_Title": "card_107_cta_title",
    //                 "ImageKey": "card_107_image",
    //                 "Order": 1,
    //                 "Title": "Create your plan",
    //                 "Description1": "lorem ipsum is simply dummy text for printing and typesetting industry.",
    //                 "Description2": "lorem ipsum is simply dummy text for printing and typesetting industry."
    //               }
    //             ]
    //           }
    //         ]
    //       },
    //       {
    //         "Id": 38,
    //         "Name": "E-SIM Only Plans",
    //         "NameKey": "subcategory_38_name",
    //         "NameColor": "subcategory_38_color",
    //         "Description": "",
    //         "DescriptionKey": "subcategory_38_description",
    //         "DescriptionColor": "subcategory_38_DescriptionColor",
    //         "Order": 2,
    //         "CTA": "CTA",
    //         "CTA_Title": "subcategory_38_cta_title",
    //         "Cards": [
    //           {
    //             "Id": 184,
    //             "Order": 1,
    //             "Shape": "SingleBanner",
    //             "CardList": [
    //               {
    //                 "Id": 128,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "600GB5G6Month",
    //                 "ProductCode": 8,
    //                 "ImageSize": "Medium",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_128_cta_title",
    //                 "ImageKey": "card_128_image",
    //                 "BannerBackgroundColor": "card_128_BannerBackgroundColor",
    //                 "Order": 1,
    //                 "CTA": "test",
    //                 "ExtraDetails": "{\"ID\":2501,\"Name\":\"600GB5G6Month\",\"IsPopular\":false,\"OriginalPrice\":900.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":900.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":900.0,\"OriginalPriceVATExc\":1620.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"600GB5G6Month\",\"Plan\":[{\"Name\":\"600GB 5G 6Month\",\"Type\":\"DATA\",\"Value\":644245094400.0,\"Unit\":\"bytes\",\"PlanID\":834,\"ChargingType\":\"RenewableBundle\",\"Validity\":180}],\"Promotions\":[],\"MonthlyNetCost\":900.000,\"MonthlyDiscountedPrice\":900.000,\"simType\":\"both\"}",
    //                 "eSIM": false
    //               },
    //               {
    //                 "Id": 129,
    //                 "Type": "CustomizedPlanBanner",
    //                 "PlanName": "SToolTest",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_129_cta_title",
    //                 "ImageKey": "card_129_image",
    //                 "BannerBackgroundColor": "card_129_BannerBackgroundColor",
    //                 "Order": 2,
    //                 "Title": "Test",
    //                 "Description1": "Fortest",
    //                 "eSIM": false
    //               }
    //             ]
    //           }
    //         ]
    //       },
    //       {
    //         "Id": 32,
    //         "Name": "Handpicked plans for you",
    //         "NameKey": "subcategory_32_name",
    //         "NameColor": "subcategory_32_color",
    //         "Description": "This Handpicked plans for you",
    //         "DescriptionKey": "subcategory_32_description",
    //         "DescriptionColor": "subcategory_32_DescriptionColor",
    //         "Order": 3,
    //         "CTA": "",
    //         "CTA_Title": "subcategory_32_cta_title",
    //         "Cards": [
    //           {
    //             "Id": 151,
    //             "Order": 1,
    //             "Shape": "HorizontalCard",
    //             "CardList": [
    //               {
    //                 "Id": 93,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "Super380",
    //                 "ProductCode": 1,
    //                 "ImageSize": "Medium",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_93_cta_title",
    //                 "ImageKey": "card_93_image",
    //                 "Order": 1,
    //                 "CTA": "Predefined Specific Plan",
    //                 "ExtraDetails": "{\"ID\":713,\"Name\":\"Super380\",\"IsPopular\":false,\"OriginalPrice\":380.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":380.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":380.0,\"OriginalPriceVATExc\":480.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"Super380\",\"Plan\":[{\"Name\":\"1000GB-NEW\",\"Type\":\"DATA\",\"Value\":-1.0,\"Unit\":\"bytes\",\"PlanID\":506,\"ChargingType\":\"RenewableBundle\",\"Validity\":30},{\"Name\":\"UnlimitedLocalMin\",\"Type\":\"VOICE-LCL\",\"Value\":-1.0,\"Unit\":\"milliseconds\",\"PlanID\":515,\"ChargingType\":\"RenewableBundle\",\"Validity\":30}],\"Promotions\":[{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":195,\\\"Type\\\":\\\"STARZPLAY\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":40.000,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_StarzPlayUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":342,\\\"Type\\\":\\\"OSN\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.750,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_OSNUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":426,\\\"Type\\\":\\\"UFC\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UFCUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":431,\\\"Type\\\":\\\"Discovery\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":14.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_DiscoveryUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":186,\\\"Type\\\":\\\"ANGHAMI\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.500,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_AnghamiUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":517,\\\"Type\\\":\\\"DATA-SOCIAL\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":-1,\\\"Duration\\\":30.0,\\\"Commitment\\\":0,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":0.0,\\\"IsOptional\\\":false,\\\"IsSelected\\\":true,\\\"GroupName\\\":null,\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":true,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UnlimitedSocial_UnlimitedGBUnlimitedMin\",\"IsMetrics\":true,\"ExtendedValidity\":0,\"Validity\":0}],\"MonthlyNetCost\":380.000,\"MonthlyDiscountedPrice\":380.000,\"simType\":\"both\"}",
    //                 "eSIM": false
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 152,
    //             "Order": 2,
    //             "Shape": "HorizontalCard",
    //             "CardList": [
    //               {
    //                 "Id": 94,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "Super215New",
    //                 "ProductCode": 1,
    //                 "ImageSize": "Large",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_94_cta_title",
    //                 "ImageKey": "card_94_image",
    //                 "Order": 1,
    //                 "CTA": "Predefined Specific Plan",
    //                 "ExtraDetails": "{\"ID\":2122,\"Name\":\"Super215New\",\"IsPopular\":false,\"OriginalPrice\":215.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":215.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":215.0,\"OriginalPriceVATExc\":215.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"Super215New\",\"Plan\":[{\"Name\":\"5KMin-NEW\",\"Type\":\"VOICE-LCL\",\"Value\":300000000.0,\"Unit\":\"milliseconds\",\"PlanID\":576,\"ChargingType\":\"RenewableBundle\",\"Validity\":30},{\"Name\":\"80GB-NEW\",\"Type\":\"DATA\",\"Value\":85899345920.0,\"Unit\":\"bytes\",\"PlanID\":792,\"ChargingType\":\"RenewableBundle\",\"Validity\":30}],\"Promotions\":[{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":195,\\\"Type\\\":\\\"STARZPLAY\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":40.000,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_StarzPlayUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":342,\\\"Type\\\":\\\"OSN\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.750,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_OSNUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":426,\\\"Type\\\":\\\"UFC\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UFCUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":431,\\\"Type\\\":\\\"Discovery\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":14.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_DiscoveryUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":186,\\\"Type\\\":\\\"ANGHAMI\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.500,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_AnghamiUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":517,\\\"Type\\\":\\\"DATA-SOCIAL\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":-1,\\\"Duration\\\":30.0,\\\"Commitment\\\":0,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":0.0,\\\"IsOptional\\\":false,\\\"IsSelected\\\":true,\\\"GroupName\\\":null,\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":true,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UnlimitedSocial_80GB5KMin\",\"IsMetrics\":true,\"ExtendedValidity\":0,\"Validity\":0}],\"MonthlyNetCost\":215.000,\"MonthlyDiscountedPrice\":215.000,\"simType\":\"both\"}"
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 160,
    //             "Order": 3,
    //             "Shape": "HorizontalCard",
    //             "CardList": [
    //               {
    //                 "Id": 102,
    //                 "Type": "DefaultBanner",
    //                 "CTA_Title": "card_102_cta_title",
    //                 "ImageKey": "card_102_image",
    //                 "Order": 1,
    //                 "Title": "Explore All Plans",
    //                 "Description1": "Choose any plan you want for your number"
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 161,
    //             "Order": 4,
    //             "Shape": "VerticalCard",
    //             "CardList": [
    //               {
    //                 "Id": 103,
    //                 "Type": "DefaultBanner",
    //                 "CTA_Title": "card_103_cta_title",
    //                 "ImageKey": "card_103_image",
    //                 "Order": 1,
    //                 "Title": "Explore All Plans",
    //                 "Description1": "Choose any plan you want for your number"
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 158,
    //             "Order": 5,
    //             "Shape": "VerticalCard",
    //             "CardList": [
    //               {
    //                 "Id": 100,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "100GB5G1Month",
    //                 "ProductCode": 8,
    //                 "ImageSize": "Medium",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_100_cta_title",
    //                 "ImageKey": "card_100_image",
    //                 "Order": 1,
    //                 "CTA": "Predefined Specific Plan",
    //                 "ExtraDetails": "{\"ID\":2497,\"Name\":\"100GB5G1Month\",\"IsPopular\":false,\"OriginalPrice\":150.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":150.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":150.0,\"OriginalPriceVATExc\":153.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"100GB5G1Month\",\"Plan\":[{\"Name\":\"100GB 5G 1Month\",\"Type\":\"DATA\",\"Value\":107374182400.0,\"Unit\":\"bytes\",\"PlanID\":830,\"ChargingType\":\"RenewableBundle\",\"Validity\":30}],\"Promotions\":[],\"MonthlyNetCost\":150.000,\"MonthlyDiscountedPrice\":150.000,\"simType\":\"both\"}"
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 162,
    //             "Order": 6,
    //             "Shape": "SwipeBanner",
    //             "CardList": [
    //               {
    //                 "Id": 104,
    //                 "Type": "CustomizedPlanBanner",
    //                 "CTA_Title": "card_104_cta_title",
    //                 "ImageKey": "card_104_image",
    //                 "Order": 1,
    //                 "Title": "Create your plan",
    //                 "Description1": "lorem ipsum is simply dummy text for printing and typesetting industry."
    //               },
    //               {
    //                 "Id": 105,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "Super70",
    //                 "ProductCode": 1,
    //                 "ImageSize": "Medium",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_105_cta_title",
    //                 "ImageKey": "card_105_image",
    //                 "Order": 2,
    //                 "CTA": "Predefined Specific Plan",
    //                 "ExtraDetails": "{\"ID\":709,\"Name\":\"Super70\",\"IsPopular\":false,\"OriginalPrice\":70.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":70.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":70.0,\"OriginalPriceVATExc\":115.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"Super70\",\"Plan\":[{\"Name\":\"15GB-NEW\",\"Type\":\"DATA\",\"Value\":16106127360.0,\"Unit\":\"bytes\",\"PlanID\":501,\"ChargingType\":\"RenewableBundle\",\"Validity\":30},{\"Name\":\"500Min-NEW\",\"Type\":\"VOICE-LCL\",\"Value\":30000000.0,\"Unit\":\"milliseconds\",\"PlanID\":509,\"ChargingType\":\"RenewableBundle\",\"Validity\":30}],\"Promotions\":[],\"MonthlyNetCost\":70.000,\"MonthlyDiscountedPrice\":70.000,\"simType\":\"both\"}"
    //               },
    //               {
    //                 "Id": 106,
    //                 "Type": "CustomizedPlanBanner",
    //                 "ImageSize": "Large",
    //                 "CTA_Title": "card_106_cta_title",
    //                 "ImageKey": "card_106_image",
    //                 "Order": 3,
    //                 "Title": "Create your plan",
    //                 "Description1": "lorem ipsum is simply dummy text for printing and typesetting industry."
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 163,
    //             "Order": 7,
    //             "Shape": "HorizontalCard",
    //             "CardList": [
    //               {
    //                 "Id": 107,
    //                 "Type": "CustomizedPlanBanner",
    //                 "CTA_Title": "card_107_cta_title",
    //                 "ImageKey": "card_107_image",
    //                 "Order": 1,
    //                 "Title": "Create your plan",
    //                 "Description1": "lorem ipsum is simply dummy text for printing and typesetting industry.",
    //                 "Description2": "lorem ipsum is simply dummy text for printing and typesetting industry."
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 164,
    //             "Order": 8,
    //             "Shape": "VerticalCard",
    //             "CardList": [
    //               {
    //                 "Id": 108,
    //                 "Type": "CustomizedPlanBanner",
    //                 "CTA_Title": "card_108_cta_title",
    //                 "ImageKey": "card_108_image",
    //                 "Order": 1,
    //                 "Title": "Create your plan",
    //                 "Description1": "lorem ipsum is simply dummy text for printing and typesetting industry."
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 185,
    //             "Order": 9,
    //             "Shape": "HorizontalCard",
    //             "CardList": [
    //               {
    //                 "Id": 130,
    //                 "Type": "PredefinedPlanBanner",
    //                 "PlanName": "Super215New",
    //                 "ProductCode": 1,
    //                 "ImageSize": "Small",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_130_cta_title",
    //                 "ImageKey": "card_130_image",
    //                 "Order": 1,
    //                 "ExtraDetails": "{\"ID\":2122,\"Name\":\"Super215New\",\"IsPopular\":false,\"OriginalPrice\":215.000,\"DiscountPercentage\":0.0,\"DiscountedPrice\":215.000,\"DiscountValue\":0.0,\"VATPercentage\":0.0,\"DiscountedPriceVATExc\":215.0,\"OriginalPriceVATExc\":215.0,\"PaymentFrequency\":\"Monthly\",\"PlanCode\":\"Super215New\",\"Plan\":[{\"Name\":\"5KMin-NEW\",\"Type\":\"VOICE-LCL\",\"Value\":300000000.0,\"Unit\":\"milliseconds\",\"PlanID\":576,\"ChargingType\":\"RenewableBundle\",\"Validity\":30},{\"Name\":\"80GB-NEW\",\"Type\":\"DATA\",\"Value\":85899345920.0,\"Unit\":\"bytes\",\"PlanID\":792,\"ChargingType\":\"RenewableBundle\",\"Validity\":30}],\"Promotions\":[{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":195,\\\"Type\\\":\\\"STARZPLAY\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":40.000,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_StarzPlayUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":342,\\\"Type\\\":\\\"OSN\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.750,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_OSNUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":426,\\\"Type\\\":\\\"UFC\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UFCUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":431,\\\"Type\\\":\\\"Discovery\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":-1,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":14.990,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_DiscoveryUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":186,\\\"Type\\\":\\\"ANGHAMI\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":0,\\\"Duration\\\":30.0,\\\"Commitment\\\":1,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":18.500,\\\"IsOptional\\\":true,\\\"IsSelected\\\":false,\\\"GroupName\\\":\\\"ContentUM\\\",\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":false,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_AnghamiUnlimited\",\"IsMetrics\":false,\"ExtendedValidity\":0,\"Validity\":0},{\"Type\":\"FreePlan\",\"Value\":\"{\\\"ID\\\":517,\\\"Type\\\":\\\"DATA-SOCIAL\\\",\\\"Unit\\\":\\\"BYTES\\\",\\\"Value\\\":-1,\\\"Duration\\\":30.0,\\\"Commitment\\\":0,\\\"PromotionDuration\\\":0,\\\"AlreadyUsed\\\":false,\\\"AlreadyStarted\\\":false,\\\"Worth\\\":0.0,\\\"IsOptional\\\":false,\\\"IsSelected\\\":true,\\\"GroupName\\\":null,\\\"WalletTopupTriggerValue\\\":0.0,\\\"IsDouble\\\":false,\\\"WalletTopupTriggerValueV2\\\":0.0,\\\"PromotionClass\\\":null,\\\"ExtensionPeriodInDays\\\":0,\\\"IsMetrics\\\":true,\\\"SelectedPackages\\\":null,\\\"DiscountAmount\\\":0.0,\\\"IsCVM\\\":false,\\\"IsStandAlone\\\":false}\",\"PromotionCode\":\"2_UnlimitedSocial_80GB5KMin\",\"IsMetrics\":true,\"ExtendedValidity\":0,\"Validity\":0}],\"MonthlyNetCost\":215.000,\"MonthlyDiscountedPrice\":215.000,\"simType\":\"both\"}",
    //                 "eSIM": true
    //               }
    //             ]
    //           }
    //         ]
    //       }
    //     ]
    //   },
    //   {
    //     "Id": 24,
    //     "DeepLink": "",
    //     "Name": "Numbers",
    //     "Order": 4,
    //     "NameKey": "main_category_24_name",
    //     "NameColor": "main_category_24_color",
    //     "Icon": "main_category_24_icon",
    //     "SubCategoryList": [
    //       {
    //         "Id": 29,
    //         "Name": "Basic Numbers",
    //         "NameKey": "subcategory_29_name",
    //         "NameColor": "subcategory_29_color",
    //         "DescriptionKey": "subcategory_29_description",
    //         "DescriptionColor": "subcategory_29_DescriptionColor",
    //         "Order": 1,
    //         "CTA": "",
    //         "Vanity": 0,
    //         "CTA_Title": "subcategory_29_cta_title",
    //         "Cards": [
    //           {
    //             "Id": 195,
    //             "Order": 1,
    //             "Shape": "NumberCard",
    //             "CardList": [
    //               {
    //                 "Id": 146,
    //                 "Type": "NumbersBanner",
    //                 "CTA_Title": "card_146_cta_title",
    //                 "ImageKey": "card_146_image",
    //                 "Order": 1,
    //                 "ExtraDetails": "{\"Vanity\":0,\"OriginalPrice\":0.000}",
    //                 "Title": "Basic Numbers",
    //                 "Number": "0573998172",
    //                 "eSIM": false
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 196,
    //             "Order": 2,
    //             "Shape": "NumberCard",
    //             "CardList": [
    //               {
    //                 "Id": 147,
    //                 "Type": "NumbersBanner",
    //                 "CTA_Title": "card_147_cta_title",
    //                 "ImageKey": "card_147_image",
    //                 "Order": 1,
    //                 "ExtraDetails": "{\"Vanity\":0,\"OriginalPrice\":0.000}",
    //                 "Title": "Basic Numbers",
    //                 "Number": "0573998329",
    //                 "eSIM": false
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 206,
    //             "Order": 3,
    //             "Shape": "SingleBanner",
    //             "CardList": [
    //               {
    //                 "Id": 161,
    //                 "Type": "DefaultBanner",
    //                 "WebImage": false,
    //                 "CTA_Title": "card_161_cta_title",
    //                 "ImageKey": "card_161_image",
    //                 "BannerBackgroundColor": "card_161_BannerBackgroundColor",
    //                 "Order": 1,
    //                 "Title": "Bring youy own number",
    //                 "eSIM": false
    //               }
    //             ]
    //           }
    //         ]
    //       },
    //       {
    //         "Id": 30,
    //         "Name": "Value Numbers",
    //         "NameKey": "subcategory_30_name",
    //         "NameColor": "subcategory_30_color",
    //         "Description": "Get 1 month 4GB & 50min Free (worth 140 SR)",
    //         "DescriptionKey": "subcategory_30_description",
    //         "DescriptionColor": "subcategory_30_DescriptionColor",
    //         "Order": 2,
    //         "Vanity": 1,
    //         "CTA_Title": "subcategory_30_cta_title",
    //         "Cards": [
    //           {
    //             "Id": 200,
    //             "Order": 1,
    //             "Shape": "NumberCard",
    //             "CardList": [
    //               {
    //                 "Id": 155,
    //                 "Type": "NumbersBanner",
    //                 "CTA_Title": "card_155_cta_title",
    //                 "ImageKey": "card_155_image",
    //                 "Order": 1,
    //                 "ExtraDetails": "{\"Vanity\":1,\"OriginalPrice\":80.000}",
    //                 "Title": "Value Numbers",
    //                 "Number": "0573989938",
    //                 "eSIM": false
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 201,
    //             "Order": 2,
    //             "Shape": "NumberCard",
    //             "CardList": [
    //               {
    //                 "Id": 156,
    //                 "Type": "NumbersBanner",
    //                 "CTA_Title": "card_156_cta_title",
    //                 "ImageKey": "card_156_image",
    //                 "Order": 1,
    //                 "ExtraDetails": "{\"Vanity\":1,\"OriginalPrice\":80.000}",
    //                 "Title": "Value Numbers",
    //                 "Number": "0573989925",
    //                 "eSIM": false
    //               }
    //             ]
    //           }
    //         ]
    //       },
    //       {
    //         "Id": 31,
    //         "Name": "Rare Numbers",
    //         "NameKey": "subcategory_31_name",
    //         "NameColor": "subcategory_31_color",
    //         "Description": "Get 2 month 40 GB & 50min Free (worth 212 SR)",
    //         "DescriptionKey": "subcategory_31_description",
    //         "DescriptionColor": "subcategory_31_DescriptionColor",
    //         "Order": 3,
    //         "CTA": "",
    //         "Vanity": 2,
    //         "CTA_Title": "subcategory_31_cta_title",
    //         "Cards": [
    //           {
    //             "Id": 149,
    //             "Order": 1,
    //             "Shape": "NumberCard",
    //             "CardList": [
    //               {
    //                 "Id": 91,
    //                 "Type": "NumbersBanner",
    //                 "ImageSize": "Large",
    //                 "CTA_Title": "card_91_cta_title",
    //                 "ImageKey": "card_91_image",
    //                 "Order": 1,
    //                 "CTA": "",
    //                 "ExtraDetails": "{\"Vanity\":2,\"OriginalPrice\":400.000}",
    //                 "Title": "Rare Numbers",
    //                 "Number": "0573892133"
    //               }
    //             ]
    //           },
    //           {
    //             "Id": 148,
    //             "Order": 2,
    //             "Shape": "NumberCard",
    //             "CardList": [
    //               {
    //                 "Id": 90,
    //                 "Type": "NumbersBanner",
    //                 "CTA_Title": "card_90_cta_title",
    //                 "ImageKey": "card_90_image",
    //                 "Order": 1,
    //                 "ExtraDetails": "{\"Vanity\":2,\"OriginalPrice\":400.000}",
    //                 "Title": "Rare Numbers",
    //                 "Number": "0573892150"
    //               }
    //             ]
    //           }
    //         ]
    //       }
    //     ]
    //   }
    // ]
  };
};
export default storefront;
